import { useSWR } from '@tiger/swr';
import { useCallback } from 'react';
import { useForm } from 'react-bootstrap-formutil';
import API from 'utils/API';
import { ZIP_CODE_NOT_MATCH_ADDRESS_TEXT } from 'utils/constants';

/**
 * @description 校验美国居住地址/邮寄地址的州编码和邮编是否匹配
 */
export const useCheckUSAPostal = () => {
    const { $setErrors, $batchState, $params } = useForm();

    // marsco帐户 获取美国地址(address)和邮编(zip code)的匹配信息用来校验
    const { data: dataZipCodeStates, mutate: mutateZipCodeStates } = useSWR<Record<number, string>>(
        API.CUSTOMER.zipCodeStates(),
        {
            immutable: true,
            dataChain: res => res.data
        }
    );

    // 校验邮政编码和州编码是否匹配，在外部使用时有try catch
    const checkPostalMatchStateCodeError = useCallback(
        async (postalFieldName: string, stateCodeFieldName: string, addressTypeFieldName: string) => {
            const postal = $params[postalFieldName];
            const stateCode = $params[stateCodeFieldName];
            const addressType = $params[addressTypeFieldName];
            let addressMap = dataZipCodeStates;

            if (!addressMap) {
                addressMap = await mutateZipCodeStates();
            }

            let errorMsg: string = '';

            if (addressType === 'USA' && postal && stateCode && addressMap && addressMap[postal] !== stateCode) {
                errorMsg = ZIP_CODE_NOT_MATCH_ADDRESS_TEXT;

                $setErrors(
                    {
                        [postalFieldName]: {
                            isMatch: errorMsg
                        },
                        [stateCodeFieldName]: {
                            isMatch: errorMsg
                        }
                    },
                    () => {
                        $batchState({
                            $dirty: true,
                            $touched: true
                        });
                    }
                );
            }

            return errorMsg;
        },
        [$setErrors, $batchState, $params, dataZipCodeStates, mutateZipCodeStates]
    );

    return {
        zipCodeStates: dataZipCodeStates,
        getZipCodeStates: mutateZipCodeStates,
        checkPostalMatchStateCodeError
    };
};
